import React from 'react'
import {CloseIcon, Icon, SideBarContainer,SideBarWrapper,SideBarLink,SideBarMenu,SideBarBtnWrap,SidebarRoute} from "./SideBarElements";
export default function SideBar({isOpen,toggle}) {
  return (
    <SideBarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={toggle}>
            <CloseIcon/>
        </Icon>
        <SideBarWrapper>
            <SideBarMenu>
                <SideBarLink to='support_us' onClick={toggle}>Donate</SideBarLink>
                <SideBarLink to='support_us' onClick={toggle}>Work With Us</SideBarLink>
                <SideBarLink to='support_us' onClick={toggle}>About</SideBarLink>
            </SideBarMenu>
            <SideBarBtnWrap>
                <SidebarRoute to='/register'>Join Now</SidebarRoute>
            </SideBarBtnWrap>
        </SideBarWrapper>
    </SideBarContainer>
  )
}